import ValueSWIcon from "../../assets/product-list-assets/gbe-1u.svg";
import type { ProductListGroup } from "../../types";

export const switchingValue: ProductListGroup = {
  id: "switchingValue",
  title: "productListGroup.switchingValue.title",
  seriesLabel: "modelCompare.seriesLabel.switchingValue",
  icon: {
    src: ValueSWIcon,
    width: 24,
    height: 24,
  },
};
